<template>
  <div id="edit">
    <mt-header fixed :title="$t('个人资料')" style="height: 40px">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>

    <div class="avter">
      <img
        v-if="userinfo.avatar"
        class="avatar2"
        style="width: 70px; height: 70px"
        :src="userinfo.avatar"
        @click="fileChoose()"
      />

      <img
        v-else
        class="avatar2"
        src="../../assets/img/avatar.jpg"
        style="width: 70px; height: 70px"
        @click="fileChoose()"
      />

      <input
        type="file"
        @change="onFileChange($event)"
        ref="inputref"
        accept="image/jpeg, image/png, image/gif"
        style="display: none"
      />

      <span class="title" v-if="!userinfo.avatar">{{ $t("点击修改") }}</span>
    </div>

    <div class="container">
      <div class="container2" @click="editname(1)">
        <span>{{ $t("昵称") }}</span>
        <span style="color: #abacac">{{ userinfo.user_nickname }}&nbsp ></span>
      </div>
      <div class="container2">
        <span>ID</span> <span style="color: #abacac">{{ userinfo.id }}</span>
      </div>
      <div class="container2">
        <span>{{ $t("手机号") }}</span>
        <span style="color: #abacac">{{ userinfo.mobile }}</span>
      </div>
      <div class="container2">
        <span>{{ $t("注册时间") }}</span>
        <span style="color: #abacac">{{
          userinfo.create_time | secoendToDate
        }}</span>
      </div>
      <div class="container3" @click="editname(2)">
        <span>{{ $t("个性签名") }}</span>
        <p style="color: #abacac; margin-top: 10px">{{ userinfo.signature }}</p>
      </div>
    </div>

    <mt-popup v-model="popupVisible" ref="popdetail">
      <div class="pop">
        <span v-if="change">{{ $t("修改昵称") }}</span>
        <span v-else>{{ $t("修改个性签名") }}</span>
        <input type="text" class="editinput" v-model.trim="zhi" />

        <div class="button">
          <!-- <div :class="{ button2: true, bg1: showbg1 }" @click="cancle">
            <span>取消</span>
          </div> -->
          <!-- <div :class="{ button3: true, bg2: showbg2 }" @click="sure">
            <span>确认</span>
          </div> -->
          <button class="button2" @click="cancle">{{ $t("取消") }}</button>
          <button class="button3" @click="sure" :disabled="zhi.length <= 0">
            {{ $t("确认") }}
          </button>
        </div>
      </div></mt-popup
    >
  </div>
</template>
<script>
// 获取 以及修改用户信息
import { httpGetUserInfo, httpPostUserInfo } from "@/api/login";
import { Toast } from "mint-ui";
import { httpUpload } from "@/api/userCenter";
export default {
  name: "Editinfo",
  data() {
    return {
      userinfo: {},
      popupVisible: false,
      change: true,
      zhi: "",
    };
  },
  methods: {
    info() {
      httpGetUserInfo()
        .then((res) => {
          this.userinfo = res.data;
        })
        .catch();
    },
    fileChoose() {
      this.$refs.inputref.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      if (this.$refs.inputref.files.length == 0) {
        return;
      } else {
        httpUpload(formData)
          .then((res) => {
            this.userinfo.avatar = res.data.http_url;
            const p = { avatar: this.userinfo.avatar };
            httpPostUserInfo(p)
              .then((res) => {})
              .catch();
            Toast(res.msg);
          })
          .catch((res) => {
            console.log(res);
          });
      }
    },
    cancle() {
      this.popupVisible = false;
      this.zhi = "";
    },
    sure() {
      this.popupVisible = false;

      if (this.change) {
        //修改昵称
        const p = { user_nickname: this.zhi };
        httpPostUserInfo(p)
          .then((res) => {
            Toast(res.msg);

            this.zhi = "";
            this.info();
          })
          .catch();
      } else {
        const p = { signature: this.zhi };
        httpPostUserInfo(p)
          .then((res) => {
            Toast(res.msg);

            this.zhi = "";
            this.info();
          })
          .catch();
      }
    },

    editname(val) {
      if (val == 2) {
        // 修改个性签名
        this.change = false;
        this.popupVisible = true;
      } else {
        this.change = true;
        this.popupVisible = true;
      }
    },
  },
  deactivated() {
    this.userinfo = {};
    this.popupVisible = false;
    this.change = true;
  },
  activated: function () {
    this.info();
  },
  watch: {},
};
</script>

<style scoped>
.mint-header {
  background: #fff;
  color: #000;
}
.edit {
  height: 100%;
}
.mint-header-title {
  font-weight: 400px;
}
.avter {
  width: 70px;
  height: 70px;
  /* background-color: pink; */
  position: relative;
  top: 70px;
  left: 50%;
  transform: translate(-50%);
}
.avatar2 {
  position: absolute;
  border-radius: 50%;
}
.title {
  position: absolute;
  left: 6px;
  top: 85px;
  color: #aeb0af;
  font-size: 14px;
}
.container {
  position: absolute;
  top: 200px;
  width: 100%;
  height: 300px;
  box-sizing: border-box;
  padding: 0px 15px;
}
.container2 {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f4f6f5;
  padding: 12px 0;
}
.container3 {
  border-bottom: 1px solid #f4f6f5;
  padding: 12px 0;
}
.pop {
  width: 350px;
  height: 149px;
  text-align: center;
  padding-top: 10px;
}
.mint-popup {
  border-radius: 8%;
}
.editinput {
  display: block;
  border: 1px solid #a9a9a9;
  width: 90%;
  height: 30px;
  margin: 20px auto;
}
.button {
  display: flex;
  justify-content: space-around;

  border-top: 1px solid #a9a9a9;
}
.button2 {
  width: 100%;
  height: 100%;
  padding: 17px 0px;
  border-right: 1px solid #a9a9a9;
  background-color: #fff;
  border-bottom-left-radius: 20%;
}
.button3 {
  width: 100%;
  height: 100%;
  padding: 17px 0px;
  color: #3497fb;
  background-color: #fff;
  border-bottom-right-radius: 20%;
}
</style>
